export default "__VITE_ASSET__d0c37a8b__"